export const ENROLL_SUBMISSION_ERROR = 'ENROLL_SUBMISSION_ERROR';
export const ENROLL_SUBMISSION_SUCCESS = 'ENROLL_SUBMISSION_SUCCESS';
